module.exports = __webpack_public_path__ + "images/marker-kerk.4b48b4.png";